import styled from "styled-components";
import { SolutionColorVariables, TextColorNames } from "@smartsuite/types";

export const StyledModalHeader = styled.div`
  display: flex;

  width: 100%;
  height: 70px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
`;

export const StyledHeaderSection = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledHeaderTitleSection = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

const StyledAutomationTitle = styled.div`
  display: flex;
  align-items: center;

  height: 38px;
  margin-left: -8px;
  border: 1px dashed transparent;
  padding-left: 8px;

  border-radius: 5px;

  font-size: 22px;
  line-height: 30px;

  transition: border-color 200ms ease;
`;

export const StyledAutomationTitleWrapper = styled(StyledAutomationTitle)`
  padding-right: 6px;

  &:hover {
    border-color: rgb(199, 200, 201);
  }
`;

export const StyledActiveAutomationTitleWrapper = styled(StyledAutomationTitle)`
  width: 100%;
  border-color: ${SolutionColorVariables.sc1};
  padding-right: 1px;
`;

export const StyledActiveAutomationTitleInput = styled.input`
  width: 100%;
  border-radius: 5px;

  font-weight: 500;
  font-size: 22px;
  font-family: inherit;
  color: ${TextColorNames.primary};
`;

export const StyledDropdownRoot = styled.div`
  z-index: -1;
  position: absolute;
`;

export const Icons = styled.div`
  display: inline-flex;

  & > button {
    margin-left: 10px;
  }
`;

export const StyledHDivider = styled.div<{
  marginL?: number;
  marginR?: number;
}>`
  margin-left: ${(props) => props.marginL ?? 0}px;
  margin-right: ${(props) => props.marginR ?? 0}px;
`;

export const DotsContainer = styled.div`
  width: 24px;
`;
